import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList, fetchDelete } from '@/api/PMS/placeAreaPrice/placeAreaPrice';
import waves from '@/directive/waves'; // 水波纹指令

import add from './add';
export default {
  name: 'ComplexTable',
  components: {
    add: add
  },
  props: ['keyValue', 'showDialog'],
  directives: {
    waves: waves
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.init();
      }
    }
  },
  data: function data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        areaId: ''
      },
      title: '',
      Id: -1,
      multipleSelection: [],
      dialogFormVisible: false
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      this.listQuery = {
        page: 1,
        limit: 10
      };
      this.total = null;
      this.getList();
    },
    handCancle: function handCancle(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogFormVisible = false;
    },
    getList: function getList() {
      var _this = this;

      this.listLoading = true;
      this.listQuery.areaId = this.keyValue;
      fetchList(this.listQuery).then(function (response) {
        _this.list = response.data.data;
        _this.total = response.data.total;
        _this.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 创建
    handleCreate: function handleCreate() {
      this.Id = -1;
      this.title = '添加';
      this.dialogFormVisible = true;
    },
    // 编辑
    handleUpdate: function handleUpdate(Id) {
      this.Id = Id;
      this.title = '编辑';
      this.dialogFormVisible = true;
    },
    delete: function _delete(Ids) {
      var _this2 = this;

      if (Ids.length > 0) {
        this.$confirm('你确定是要删除这些记录, 是否继续?', '提示').then(function () {
          fetchDelete(Ids).then(function (response) {
            _this2.getList();

            _this2.Alert({
              alertType: 'delete'
            });
          });
        });
      } else {
        this.Alert({
          alertType: 'nodata'
        });
      }
    },
    handleDelete: function handleDelete(Id) {
      var Ids = [];
      Ids.push(Id);
      this.delete(Ids);
    },
    handleDeletes: function handleDeletes() {
      var Ids = [];
      this.multipleSelection.forEach(function (row) {
        Ids.push(row.id);
      });
      this.delete(Ids);
    }
  }
};